import React, { useState } from 'react';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import Form from '@rjsf/mui';
import { useTranslation } from 'react-i18next';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';

import { themeGenerator } from '../../utils';
import { CounterWidget, ImageWidget } from '../../rjsf_widgets';
import './RJSForm.scss';

const theme = themeGenerator(createTheme);

const RJSForm = ({ formData, schema, uiSchema, onChange }) => {
	const [data, setData] = useState(formData);
	const { t, i18n } = useTranslation();
	console.log('i18n.language', i18n.language);
	const handleFormDataChange = ({ formData }) => {
		console.log('formData', formData);
		// setData(formData);
		if (onChange) {
			onChange(formData);
		}
	};

	const getLocalizedTitle = (title) => {
		if (typeof title === 'object' && title !== null) {
			return title[i18n.language] || title[Object.keys(title)[0]];
		}
		return title;
	};

	const getLocalizedProperties = (properties) => {
		return Object.keys(properties).reduce((acc, key) => {
			const property = properties[key];
			const title = getLocalizedTitle(property.title);
			let newProperty = {
				...property,
				title,
			};

			if (property.properties) {
				newProperty.properties = getLocalizedProperties(property.properties);
			}

			acc[key] = newProperty;
			return acc;
		}, {});
	};

	const translatedSchema = {
		...schema,
		properties: getLocalizedProperties(schema.properties),
	};

	const widgets = {
		counterWidget: CounterWidget,
		imageWidget: ImageWidget,
	};

	return (
		<ThemeProvider theme={theme}>
			<Form
				validator={validator}
				schema={translatedSchema}
				uiSchema={uiSchema}
				formData={formData}
				widgets={widgets}
				onChange={handleFormDataChange}
			/>
		</ThemeProvider>
	);
};

export default RJSForm;
